<template>
	<v-card data-tour-scope="additional-tab-form">
		<v-toolbar fixed dark color="primary">
			<v-btn icon dark @click="close">
				<v-icon>mdi-close</v-icon>
			</v-btn>
			<v-toolbar-title>Modifica tab aggiuntiva</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-toolbar-items>
				<v-btn dark text data-tour="save" @click.prevent="confirm"> Salva </v-btn>
			</v-toolbar-items>
		</v-toolbar>
		<v-container>
			<AdditionalTabFormBody :item="item" :errors-trans="errorsTrans" :alerts="alerts" :altre="altreTab" :lang="lingueAttive[0] || 'it'" :indice-corrente="indiceCorrente" @traduci="traduci" />
		</v-container>
		<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :vertical="snackbar.mode === 'vertical'">
			<span v-html="snackbar.text"></span>
			<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
		</v-snackbar>
	</v-card>
</template>

<script>
import _ from 'lodash';
import AdditionalTabFormBody from './AdditionalTabFormBody.vue';
import additionalTabForm from './additionalTabForm';

export default {
	name: 'Edit',
	components: { AdditionalTabFormBody },
	mixins: [additionalTabForm],
	props: ['id'],
	computed: {
		// posto della tab nell'elenco salvato, per l'anteprima dell'ordine
		indiceCorrente() {
			const i = (this.getSettings.additional_tabs || []).findIndex(t => t._id === this.id);
			return i < 0 ? null : i;
		},
	},
	async mounted() {
		await this.fetchSettings();
		const tab = _.find(this.getSettings.additional_tabs, { _id: this.id });
		if (!tab) return;
		this.item.position = tab.position;
		this.item.is_active = tab.is_active;
		this.preparaTrans(tab.trans);
	},
	methods: {
		// la tab modificata al suo posto, senza toccare lo store prima della risposta
		listaDaSalvare() {
			return (this.getSettings.additional_tabs || []).map(t => (t._id === this.id ? { ...t, position: this.item.position, is_active: this.item.is_active, trans: this.item.trans } : t));
		},
	},
};
</script>
